import '@coreui/coreui/dist/css/coreui.min.css';
import '@coreui/icons/css/coreui-icons.css';
import 'font-awesome/css/font-awesome.min.css';
import 'material-components-web/dist/material-components-web.min.css';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'simple-line-icons/css/simple-line-icons.css';
import { DefaultLayout, SignIn } from './navigation/routes';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

toast.configure();

const App: React.FC = () => {
  const defaultLayout = (props: any) => <DefaultLayout {...props} />;
  const signIn = (props: any) => <SignIn {...props} />;

  return (
    <div>
      <BrowserRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route exact={true} path="/signin" render={signIn} />
            <Route path="/" render={defaultLayout} />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    </div>
  );
};

export default App;
